import DiscussionReply from '@/models/DiscussionReply.js';
import DiscussionThread from '@/models/DiscussionThread.js';
import Model from '@/models/Model.js';

export default class InboxDiscussion extends Model {
    static entity = 'inbox_discussions';

    static modelName = 'InboxDiscussion';

    constructor(props) {
        super(props);

        const isThread = props.discussion_type === 'thread';

        this.isThread = isThread;
        this.discussionModel = isThread ? DiscussionThread : DiscussionReply;
        this.class = isThread ? 'App\\Models\\DiscussionThread' : 'App\\Models\\DiscussionReply';
    }

    static fields() {
        return {
            id: this.number(null),
            discussion_type: this.string(null),
            title: this.string(null),
            body: this.string(null),
            user: this.attr(null),
            course: this.attr(null),
            read: this.boolean(null),
            created_at: this.attr(null),
        };
    }

    get model() {
        return this.discussion_type === 'thread' ? DiscussionThread : DiscussionReply;
    }
}
